import * as React from "react"
const FlagIcon = ({ bgColor = "none" }) => {
	return (
		<svg width="9" height="10" viewBox="0 0 9 10" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
			<path d="M9 4.58333L0 0L0 1.25L0 10L9 4.58333Z" fill="#E281A8" />
		</svg>
	)
}

export default FlagIcon
